import useId from '../utils/useId';
import * as React from 'react';
export const firsthorizonSvg = React.forwardRef(function firsthorizonSvgInner(
  props,
  ref,
) {
  const baseId = useId();
  const id_0 = baseId + '_0';
  const id_1 = baseId + '_1';
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        clipPath: `url(#bi_firsthorizon__a_${id_0})`,
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#fff',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement(
        'g',
        {
          clipPath: `url(#bi_firsthorizon__b_${id_1})`,
        },
        /*#__PURE__*/ React.createElement('path', {
          fill: '#fff',
          d: 'M0 0h32v32H0z',
        }),
        /*#__PURE__*/ React.createElement('path', {
          d: 'M32 21.597V6.244C17.937 8.76 5.883 19.919 0 29.064V32h18.655l-2.296-3.943-9.83.42 8.18-6.125-.072-6.544 7.749 1.762 9.47-4.698-2.654 7.047L32 21.597Z',
          fill: '#003B80',
        }),
        /*#__PURE__*/ React.createElement('path', {
          d: 'M21.073 32H32v-7.805l-6.657 1.754L21.073 32Z',
          fill: '#003B80',
        }),
        /*#__PURE__*/ React.createElement('path', {
          fillRule: 'evenodd',
          clipRule: 'evenodd',
          d: 'M0 0h32v3.909c-11.91.582-26.188 9.48-32 16.384V0Z',
          fill: '#ED1B2E',
        }),
      ),
    ),
    /*#__PURE__*/ React.createElement(
      'defs',
      null,
      /*#__PURE__*/ React.createElement(
        'clipPath',
        {
          id: `bi_firsthorizon__a_${id_0}`,
        },
        /*#__PURE__*/ React.createElement('path', {
          fill: '#fff',
          d: 'M0 0h32v32H0z',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'clipPath',
        {
          id: `bi_firsthorizon__b_${id_1}`,
        },
        /*#__PURE__*/ React.createElement('path', {
          fill: '#fff',
          d: 'M0 0h32v32H0z',
        }),
      ),
    ),
  );
});
firsthorizonSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var firsthorizon = {
  category: 'brand',
  colorable: false,
  name: 'firsthorizon',
  svg: firsthorizonSvg,
};
